// extracted by mini-css-extract-plugin
export var askAiIcon = "_mg-j";
export var category = "_mg-9";
export var categoryHeader = "_mg-e";
export var container = "_mg-0";
export var group = "_mg-a";
export var groupItems = "_mg-f";
export var groupSeparator = "_mg-k";
export var loading = "_mg-1";
export var noResults = "_mg-3";
export var placeholder = "_mg-2";
export var resultContent = "_mg-5";
export var resultIcon = "_mg-c";
export var resultItem = "_mg-g";
export var resultMeta = "_mg-8";
export var resultSubtitle = "_mg-7";
export var resultSuffix = "_mg-i";
export var resultTitle = "_mg-6";
export var resultsList = "_mg-4";
export var searchGroup = "_mg-d";
export var selected = "_mg-h";
export var subgroup = "_mg-b";